import { render, staticRenderFns } from "./detailsSpecialAct.vue?vue&type=template&id=5ae7c2c0&scoped=true&"
import script from "./detailsSpecialAct.vue?vue&type=script&lang=js&"
export * from "./detailsSpecialAct.vue?vue&type=script&lang=js&"
import style0 from "./detailsSpecialAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsSpecialAct.vue?vue&type=style&index=1&id=5ae7c2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7c2c0",
  null
  
)

component.options.__file = "detailsSpecialAct.vue"
export default component.exports